/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ActionItemKeyType {
    ResequenceStops = 0,
    CancelTrip = 1,
    AddOrder = 2,
    RemoveOrder = 3,
    ToggleMap = 4,
    TripSummary = 5,
    CarrierAgreement = 6,
    DryRunTrip = 7,
    TransactionLogs = 8,
}
